// extracted by mini-css-extract-plugin
module.exports = {"AppRoot":"App_AppRoot__XEV8T"};